import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="footer footer--legal" id="contact">
      <div className="footer-legal">
        <p>
          Use of this site signifies your acceptance of the{" "}
          <Link to="/terms">Terms of Service</Link>,{" "}
          <Link to="/code-of-conduct">Code of Conduct</Link>, and{" "}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
        <p>All software copyright © 2024–2026, TNK Main / AI For POS. All rights reserved.</p>
      </div>
    </footer>
  );
}
